module.exports = __webpack_public_path__ + "img/340x66_logo@2x.3059bfc4.png";